module.exports = __webpack_public_path__ + "static/media/the-right-information-at-the-right-time-03.2d233180.png";